module.exports = __webpack_public_path__ + "images/default_avatars/noon@2x-81625b319d0fe7c1fd4651c38bf54eae.jpg";